export const SECTIONS = {
    HOME: 'home',
    RESULTS: 'results',
    ACTION_PLAN: 'action-plan',
    KITS: 'kits',
    ACCOUNT: 'account',
    CONSULTS: 'consults',
    AUTH: 'auth',
    GUIDES: 'guides',
    PROFILE: 'profile',
    SETTINGS: 'settings',
    ORDERING: 'ordering',
    MAYO_ORDERING: 'mayo-ordering',
    INVOICES: 'invoices',
    USERS: 'users',
    ORDERS: 'orders',
    PARTNER: 'partner',
    SYSTEM: 'system',
};
export const DOMAINS = {
    ACCOUNT: 'account',
    KITS: 'kits',
    RESULTS: 'results',
    SURVEYS: 'surveys',
    CONDITIONS: 'conditions',
    ACTION_PLAN: 'actionPlan',
    MICROBIOME: 'microbiome',
    SUBSCRIPTIONS: 'subscriptions',
    PDF_REPORT: 'pdfReport',
    CONSULTS: 'consults',
    FEEDBACK: 'feedback',
    DISCOUNTS: 'discounts',
    INSIGHTS: 'insights',
    CONTENT: 'content',
    PRACTITIONERS: 'practitioners',
    PARTNERS: 'partners',
    MSS: 'mss',
    SEEDING: 'seeding',
    RESEARCH_STUDIES: 'researchStudies',
    SYSTEM: 'system',
    METRICS: 'metrics',
};
export const IMPORTANCE = {
    CRITICAL: 'critical',
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low',
};
export const INTEGRATIONS = {
    STRIPE: 'stripe',
    CALENDLY: 'calendly',
};
// Canonical identifiers for apps that originate tiny-ai chat requests.
// Used as the 'app' tag on backend Sentry events and the `context.app`
// field on chat mutation input.
export const APPS = {
    TINY_AI: 'tiny-ai',
    RESULTS_PORTAL: 'results-portal',
    OPS_DASHBOARD: 'ops-dashboard',
};
//# sourceMappingURL=constants.js.map